import type { ReactNode } from 'react';
import './player.css';

/** Shared player-facing composition; working score grids retain their own styles. */
export function PlayerPage({
  children,
  className = '',
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={`player-page ${className}`}>{children}</div>;
}

export function LeaguePicker({
  leagues,
  value,
  onChange,
}: {
  leagues: { leagueId: string; name: string }[];
  value: string | null | undefined;
  onChange: (id: string) => void;
}) {
  return (
    <div className="player-league-picker" role="group" aria-label="Choose league">
      {leagues.map((league) => (
        <button
          key={league.leagueId}
          type="button"
          aria-pressed={value === league.leagueId}
          onClick={() => onChange(league.leagueId)}
        >
          {league.name}
        </button>
      ))}
    </div>
  );
}
